
<template>
  <el-dialog
    :title="getTitle"
    :visible.sync="value"
    width="50%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      :inline="true"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="项目组名称"
            prop="groupName"
            style="width:100%"
          >
            <el-input
              v-model="entityData.groupName"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveData"
      >保  存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import LoadingOptions from '@/components/commonSetting'
export default {
  components: {},
  props: {
    value: Boolean,
    entityId: { type: Number, default: null },
    groupType: { type: String, default: '' }
  },
  data() {
    return {
      title: '项目组',
      entityData: {},
      rules: {
        groupName: [
          { required: true, message: '请输入项目组名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    getTitle() {
      return (this.entityId ? '修改' : '新增') + this.title
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleOpenDailog() {
      const loading = this.$loading(LoadingOptions.loadOptions)
      pathReq.item('/api/services/app/td03/GetEdittd03', this.entityId)
        .then((resp) => {
          console.log(resp)
          this.entityData = resp.data.result.entityData
          loading.close()
        })
    },
    handleCloseDailog() {
      this.$emit('input', false)
    },
    handleSaveData() {
      this.$refs.entityData.validate(valid => {
        if (valid) {
          this.entityData.id = this.entityId
          this.entityData.groupTypeDictKey = this.groupType
          const loading = this.$loading(LoadingOptions.loadOptions)
          pathReq
            .postForm('/api/services/app/td03/CreateOrUpdatetd03',
              {
                entityData: this.entityData
              })
            .then(() => {
              this.entityData = {}
              loading.close()
              this.$message.success('保存成功')
              this.$emit('save-success')
              this.$emit('input', false)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

